import styled from '@emotion/styled';
import { Colors } from 'styles/variables/colors';

export const Text = styled.span`
    width: 100%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    cursor: default;
    font-family: 'Assistant', sans-serif;
    font-weight: 600;
    font-size: 18px;
    color: ${Colors.darkGray};
    line-height: 20px;
`;
